import "./CustomQuote.scss";
import CustomForm from "../../components/CustomForm/CustomForm";
import { useState } from "react";
import logo from "../../assets/logo/logo.png";

const CustomQuote = () => {
  const [showCookies, setShowCookies] = useState(false);
  const [showConfections, setShowConfections] = useState(false);
  const [showCakes, setShowCakes] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  return (
    <div>
      <h1 className="custom-quote__title">Custom Quotes</h1>
      <div className="custom-quote">
        <div>
          {!imageUrl && (
            <img src={logo} alt="logo" className="custom-quote__logo" />
          )}
          {imageUrl && (
            <img src={imageUrl} alt="images" className="custom-quote__img" />
          )}
        </div>
        <CustomForm
          imageUrl={imageUrl}
          setImageUrl={setImageUrl}
          showCookies={showCookies}
          setShowCookies={setShowCookies}
          showConfections={showConfections}
          setShowConfections={setShowConfections}
          showCakes={showCakes}
          setShowCakes={setShowCakes}
        />
      </div>
    </div>
  );
};

export default CustomQuote;
